module.exports = __webpack_public_path__ + "staticcomp/img/share.440b4cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/11/share.jpg
// module id = pHMv
// module chunks = 39